import React, { useState, useEffect, useRef } from "react";
import {
  Loader,
  Dimmer,
  TableCell,
  TableRow,
  TableBody,
} from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import {
  seleccionarCampo,
  formatMoneda,
  validaSoloNumero,
  validaMonto,
  formatoMonto,
} from "../../util/varios";
import moment from "moment";
import CatalogoCliente from "../../catalogos/catalogoCliente";
import useTableScroll from "../useTableScroll";
import { ProcesosMontosAnticipos } from "./modalAgreProcesosMontosAnticipo";
import CatalogoListAnticipos from "../../catalogos/catalogoAnticipos";
import { ImagenAnticipo } from "./modalImagenAnticipo";
import { ImagenDivisa } from "./modalImagenDivisa";

const TablaAnticipos = () => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const accbtnndebito = JSON.parse(sessionStorage.getItem("accbtnndebitoc"));
  const ncaja = JSON.parse(sessionStorage.getItem("numcaja"));
  const cmbCedula = ["J", "V", "G", "P"];

  const headCells = [
    { label: "FORMA DE PAGO", textAlign: "center" },
    { label: "MONTO", textAlign: "center" },
    { label: "MONTO AL CAMBIO", textAlign: "center" },
    { label: "", textAlign: "center" },
  ];

  const txtFecha = useRef();
  const txtConcepto = useRef();
  const btnIncluir = useRef();
  const btnConsultar = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnProducto = useRef();
  const cmbRif = useRef();
  const txtRif = useRef();
  const txtNumAnticipo = useRef();
  const txtRifVende = useRef();
  const txtDias = useRef();
  const txtFechaVencimiento = useRef();

  const [body, setBody] = useState(null);
  const [operacion, setOperacion] = useState(0);
  const [opea, setOpea] = useState(0);
  const [habilitado, setHabilitado] = useState(false);
  const [habilitarCat, setHabilitarCat] = useState(true);
  const [habilitadoBot, setHabilitadoBot] = useState(true);
  const [habilitadoCli, setHabilitadoCli] = useState(false);
  const [numNota, setNumNota] = useState("");
  const [cedRif, setCedRif] = useState("");
  const [nomVendedor, setNomVendedor] = useState("");
  const [idmone, setIdmone] = useState(0);
  const [valormone, setValormone] = useState(0.0);
  const [idCliente, setIdCliente] = useState("");
  const [nomCliente, setNomCliente] = useState("");
  const [dirCliente, setDirCliente] = useState("");
  const [visible, setVisible] = useState(0);
  const [desde, setDesde] = useState(0);
  const [habilitarMoneda, setHabilitarMoneda] = useState(false);
  const [modalAnticipo, setModalAnticipo] = useState(false);
  const [modalDivisa, setModalDivisa] = useState(false);
  const [combomoneda, setComboMoneda] = useState([]);
  const [imagenanticipo, setImagenanticipo] = useState(null);
  const [imagendivisa, setImagendivisa] = useState(null);
  const [idvende, setIdvende] = useState(0);
  const [numfactu, setNumfactu] = useState("");
  const [totalmoneda, setTotalmoneda] = useState(0.0);
  const [totaldolares, setTotaldolares] = useState(0.0);
  const [estatusa, setEstatusa] = useState("");
  const [estatusreve, setEstatusreve] = useState("");
  const [totales, setTotales] = useState(0.0);
  const [mostrar, setMostrar] = useState(false);
  const [records, setRecords] = useState([]);
  const [tituloHeader, setTituloHeader] = useState("Gestionar Anticipos.");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [moneda, setMoneda] = useState({
    idmoneda: "1",
    descripcion: "BOLIVARES",
    simbolo: "Bs",
    predeterminada: true,
    subpredeterminada: false,
    valormoneda: 1.0,
  });
  const [monedaSub, setMonedaSub] = useState({
    idmoneda: "2",
    descripcion: "DOLARES",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 0.0,
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mostrar1, setMostrar1] = useState(false);
  const [catalogoCliente, setCatalogoCliente] = useState(false);
  const [catalogoNota, setCatalogoNota] = useState(false);
  const [activate, setActivate] = useState(false);
  const [visibleBtn, setVisibleBtn] = useState("visible");

  const handleInputNumeroChange = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "idnotaentre") {
          seleccionarAnticipo(event.target.value);
        }
      }
    }
  };

  const validarCliente = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (cmbRif.current.value !== "" && event.target.value !== "") {
        let rif = cmbRif.current.value + event.target.value;
        seleccionarCliente(rif, event.which);
      }
    }
  };

  const { TblContainer, TblHead } = useTableScroll(headCells, filterFn);

  const blanquear = () => {
    setTituloHeader("Gestionar Anticipos.");
    setBody();
    setActivate(false);
    setOperacion(0);
    setHabilitado(false);
    setHabilitarMoneda(false);
    setHabilitadoCli(false);
    setHabilitadoBot(true);
    setHabilitarCat(true);
    setImagenanticipo(null);
    setImagendivisa(null);
    setVisible(0);
    setIdvende(0);
    setVisibleBtn("visible");
    setMoneda({
      idmoneda: "1",
      descripcion: "BOLIVARES",
      simbolo: "Bs",
      predeterminada: false,
      valormoneda: 1.0,
    });
    cmbRif.current.selectedIndex = -1;
    txtRif.current.value = "";
    txtNumAnticipo.current.value = "";
    setNumNota("");
    setNomCliente("");
    setDirCliente("");
    setNomVendedor("");
    setCedRif("");
    txtFecha.current.value = "";
    txtConcepto.current.value = "";
    setRecords([]);
    setTotaldolares(0.0);
    setTotales(0.0);
    setTotalmoneda(0.0);
    setEstatusa("");
    setEstatusreve("");
    setNumfactu("");
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const handleCloseMensaje = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 3) {
      setDesde(0);
      window.location.href = "/inicio";
    } else if (desde === 4) {
      setDesde(0);
    }
  };

  const onChange = (e) => {
    if (e.target.name === "cedula") {
      setIdCliente();
      setNomCliente("");
      setDirCliente("");
    }
  };

  const seleccionarCliente = (rif, tecla, ids) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "";
    let nomid2 = "cliente";
    let id;
    if (rif === 0 && tecla === 0) {
      nomid = "idagente";
      id = ids;
    } else {
      nomid = "rif";
      id = rif;
    }
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            cmbRif.current.value = response.data.rif.trim().substring(0, 1);
            txtRif.current.value = response.data.rif.trim().substring(1, 10);
            setIdCliente(response.data.idagente);
            setNomCliente(response.data.nombre);
            setDirCliente(response.data.direccion.trim());
            if (tecla === 13) {
              txtFecha.current.focus();
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un cliente con este codigo",
              icono: "informacion",
            });
            txtRif.current.value = "";
            cmbRif.current.selectedIndex = -1;
            if (tecla === 13) {
              txtRif.current.focus();
            }
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarVendedor = (idv) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";
    let nomid2 = "vendedor";
    let id = idv === null ? "0" : idv;
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setCedRif(response.data.rif);
            setNomVendedor(response.data.nombre);
            setIdvende(response.data.idagente);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El usuario no tiene un vendedor asociado",
              icono: "informacion",
            });
            blanquear();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarDetalle = (id, vmoney) => {
    let campos = "*";
    let nomtab = "pagodetalle";
    let nomid = "idpago";
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            let datos = [];
            let idmoney;
            let predeterminada = 0.0;
            let valormoney = 0.0;
            let simbolo;

            for (let i = 0; i < response.data.length; i++) {
              idmoney = response.data[i].idmoneda;

              for (let a = 0; a < combomoneda.length; a++) {
                if (parseInt(combomoneda[a].idmoneda) === parseInt(idmoney)) {
                  simbolo = combomoneda[a].simbolo;

                  if (combomoneda[a].subpredeterminada === true) {
                    valormoney = response.data[i].factorcambio;
                    predeterminada = response.data[i].factorcambio;
                  } else {
                    valormoney = response.data[i].factorcambio;
                    predeterminada = response.data[i].factorcambio;
                  }
                }
              }

              datos.push({
                forma:
                  response.data[i].tipo === "1"
                    ? "Efectivo Bs"
                    : response.data[i].tipo === "2"
                    ? "Tarjeta(Debito) Bs"
                    : response.data[i].tipo === "3"
                    ? "Tarjeta(Crédito) Bs"
                    : response.data[i].tipo === "4"
                    ? "Pago Movil Bs"
                    : response.data[i].tipo === "5"
                    ? "Deposito Bancario Bs"
                    : response.data[i].tipo === "6"
                    ? "Transferencia Bancaria Bs"
                    : "Divisa" + " " + simbolo,
                montos: response.data[i].monto,
                fechapago: response.data[i].fechaemision,
                tipodivisa: response.data[i].idmoneda,
                montoalcambio:
                  response.data[i].tipo === "7"
                    ? response.data[i].monto * parseFloat(valormoney)
                    : response.data[i].monto,
                montodefinic:
                  response.data[i].tipo === "7"
                    ? (response.data[i].monto * parseFloat(valormoney)) /
                      parseFloat(predeterminada)
                    : response.data[i].monto / parseFloat(predeterminada),
                notacredito: response.data[i].numcredito,
                valormoneda: response.data[i].factorcambio,
                idbanco: response.data[i].idcuenta,
                referencia: response.data[i].nroreferencia,
                simbolo: simbolo,
              });
            }

            let montototal = 0.0;

            for (let e = 0; e < datos.length; e++) {
              montototal =
                parseFloat(montototal) + parseFloat(datos[e].montoalcambio);
            }

            setRecords(datos);
            setTotales(montototal);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarAnticipo = (num) => {
    let campos = "*";
    let nomtab = "registropago";
    let nomid = "numpago";
    let nomid2 = "tipofac";
    let id = num;
    let tipo = "AN";
    let endpoint = "";

    endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${tipo}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            let montod = 0.0;

            seleccionarCliente(0, 0, response.data.idcliente);
            seleccionarVendedor(response.data.idvendedor);
            setNumNota(response.data.numpago);

            setEstatusa(response.data.status);
            setEstatusreve(response.data.statusreverso);

            setNumfactu(response.data.numfactura);
            txtFecha.current.value = moment(response.data.fecharegistro).format(
              "YYYY-MM-DD"
            );
            txtConcepto.current.value = response.data.concepto.trim();
            seleccionarDetalle(response.data.idpago, response.data.valormoneda);
            setTotalmoneda(parseFloat(response.data.valormoneda));

            if (response.data.imagenanticipo === "subir.png") {
              setImagenanticipo(null);
            } else {
              setImagenanticipo(response.data.imagenanticipo);
            }

            if (response.data.imagendivisa === "subir.png") {
              setImagendivisa(null);
            } else {
              setImagendivisa(response.data.imagendivisa);
            }

            montod = response.data.total;
            setTotaldolares(montod);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un Anticipo con este Código",
              icono: "informacion",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const onCatalogoCliente = (values) => {
    setCatalogoCliente(false);
    cmbRif.current.value = values.rif.substring(0, 1);
    txtRif.current.value = values.rif.substring(1);
    setIdCliente(values.idagente);
    setNomCliente(values.nombre);
    setDirCliente(values.direccion);
  };

  const seleccionarMonedas = () => {
    let campos =
      "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
    let nomtab =
      "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
    let orden = "m.idmoneda";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setComboMoneda(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const onChangeValidar = () => {
    let sigue = true;
    if (opea === 1) {
      if (txtFecha.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Seleccione la Fecha !",
          icono: "informacion",
        });
        sigue = false;
        txtFecha.current.focus();
      } else if (txtRif.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Seleccione el Cliente !",
          icono: "informacion",
        });
        sigue = false;
        txtRif.current.focus();
      } else if (txtRifVende.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Los Datos del Vendedor no deben ir Vacios !",
          icono: "informacion",
        });
        sigue = false;
        txtRifVende.current.focus();
      } else if (txtConcepto.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Describa el Concepto del Anticipo !",
          icono: "informacion",
        });
        sigue = false;
        txtConcepto.current.focus();
      } else if (records.length <= 0) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Introduzca el Pago !",
          icono: "informacion",
        });
        sigue = false;
      } else {
        sigue = true;
      }

      if (sigue) {
        let pago = [];
        let pagodetalle = [];
        let montosd = "0.00";

        pago.push({
          idpago: 0,
          numpago: 0,
          concepto: txtConcepto.current.value,
          idcliente: idCliente,
          idvendedor: idvende,
          idfactura: "",
          monto: totaldolares,
          descuento: "",
          iva: "",
          montoiva: montosd,
          abono: montosd,
          total: totaldolares,
          sobrante: montosd,
          fecharegistro: txtFecha.current.value,
          tipofac: "AN",
          numfactura: "",
          status: 0,
          idmoneda: idmone,
          valormoneda: valormone,
        });

        for (let i = 0; i < records.length; i++) {
          pagodetalle.push({
            idpago: 0,
            monto: records[i].montos,
            nroreferencia: records[i].referencia,
            idmoneda: records[i].tipodivisa,
            numcredito: records[i].notacredito,
            factorcambio: records[i].valormoneda,
            moneda:
              records[i].simbolo === "$"
                ? "DOLAR"
                : records[i].simbolo === "€"
                ? "EURO"
                : "BOLIVARES",
            tipo: records[i].tipo,
            fechaemision: records[i].fechapago,
            idcuenta: records[i].idbanco,
          });
        }

        setBody({
          pago: pago,
          pagodeta: pagodetalle,
          app: false,
          ncaja: ncaja,
        });

        let msg = "";
        if (opea === 1) {
          msg = "Esta Seguro de Registrar este Pago.";
        }

        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: msg,
          icono: "confirmacion",
        });
      }
    }
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/registropago/${opea}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (opea === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Pago Registrado Correctamente",
              icono: "exito",
            });

            var reporte = "ReporteAnticipos";
            let opera = 3;
            let condi = "'" + response.data.numeropago  + "'";
            let orden = "";
            let tipo = "AN";
            let desdec = "'" + "" + "'";
            let hastac = "'" + "" + "'";
            window.open(
              op.reportes +
                "/finanzas?afiliado=" +
                afiliado +
                "&reporte=" +
                reporte +
                "&NUMPAGO=" +
                condi +
                "&OP=" +
                opera +
                "&TIPOPAGO=" +
                tipo +
                "&orden=" +
                orden +
                "&desde=" +
                desdec +
                "&hasta=" +
                hastac,
              "Planilla",
              "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );

          } else if (opea === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Pago Registrado Correctamente",
              icono: "exito",
            });
          }
          blanquear();
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = error.response.data.message;
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      if (accbtnndebito && accbtnndebito.toString().substring(0, 1) === "1") {
        setTituloHeader("Incluir Anticipo.");
        setHabilitadoBot(false);
        setVisibleBtn("hidden");
        setOpea(op);
        setHabilitado(true);
        setHabilitadoCli(true);
        setHabilitarMoneda(true);
        seleccionarVendedor(idVendedor);
        setHabilitarCat(true);
        txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 4) {
      if (accbtnndebito && accbtnndebito.toString().substring(2, 3) === "1") {
        setTituloHeader("Consultar Anticipo.");
        setHabilitadoBot(false);
        setVisibleBtn("hidden");
        setOpea(op);
        setHabilitarCat(false);
        setHabilitado(false);
        setHabilitarMoneda(true);
        setHabilitadoCli(false);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      blanquear();
    }
  };

  const handleInputChange = (event) => {
    event.preventDefault();
    if (event.which === 13) {
      if (event.target.name === "fecha") {
        event.target.value = moment(event.target.value).format("YYYY-MM-DD");
        btnProducto.current.focus();
      } else if (event.target.name === "dias") {
        let dias = txtDias.current.value;
        if (txtDias.current.value > 0) {
          let fechaV = moment(fechasistema)
            .add(dias.toString(), "days")
            .format("YYYY-MM-DD");
          let cambia = event.target.value;
          let dd =
            dias === cambia
              ? cambia
              : txtFechaVencimiento.current.value.substring(8, 10);

          if (event.target.value !== dd) {
            let fechaV = moment(fechasistema)
              .add(dias.toString(), "days")
              .format("YYYY-MM-DD");
          }
        }
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.name === "fecha") {
        event.target.value = moment(event.target.value).format("YYYY-MM-DD");
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  useEffect(() => {
    seleccionarMonedas();
  }, []);

  const handleAceptaDatos = (values) => {
    setMostrar1(false);

    let predeterminada;
    let totalm = 0.0;
    let idmoney;
    let valormoney = 0.0;
    let indx = 0;

    let datos = [...records];
    let montototal = 0.0;

    for (let b = 0; b < datos.length; b++) {
      indx = indx + 1;
    }

    for (let i = 0; i < values.length; i++) {
      idmoney = values[i].tipodivisa;

      for (let a = 0; a < combomoneda.length; a++) {
        if (parseInt(combomoneda[a].idmoneda) === parseInt(idmoney)) {
          valormoney = combomoneda[a].valormoneda;
        }

        if (combomoneda[a].subpredeterminada === true) {
          predeterminada = combomoneda[a].valormoneda;
          setValormone(combomoneda[a].valormoneda);
          setIdmone(combomoneda[a].idmoneda);
        }
      }

      datos.push({
        forma:
          values[i].formapago === 1
            ? "Efectivo Bs"
            : values[i].formapago === 2
            ? "Tarjeta(Debito) Bs"
            : values[i].formapago === 3
            ? "Tarjeta(Crédito) Bs"
            : values[i].formapago === 4
            ? "Pago Movil Bs"
            : values[i].formapago === 5
            ? "Deposito Bancario Bs"
            : values[i].formapago === 6
            ? "Transferencia Bancaria Bs"
            : "Divisa" + " " + values[i].simbolo,
        montos: values[i].monto,
        fechapago: values[i].fecha,
        tipo: values[i].formapago,
        tipodivisa: values[i].tipodivisa,
        montoalcambio:
          values[i].formapago === 7
            ? values[i].monto * valormoney
            : values[i].monto,
        montodefinic:
          values[i].formapago === 7
            ? (values[i].monto * valormoney) / predeterminada
            : values[i].monto / predeterminada,
        index: indx,
        notacredito: values[i].notacredito,
        valormoneda: values[i].valormoneda,
        idbanco: values[i].idbanco,
        referencia: values[i].referencia,
        simbolo: values[i].simbolo,
      });
    }

    for (let e = 0; e < datos.length; e++) {
      montototal = parseFloat(montototal) + parseFloat(datos[e].montodefinic);
    }

    totalm = montototal * predeterminada;

    setTotaldolares(montototal);
    setTotales(totalm);
    setRecords(datos);
  };

  const calcularTotales = (data, datos) => {
    let predeterminada;
    let montototal = 0.0;
    let totalm = 0.0;

    for (let a = 0; a < combomoneda.length; a++) {
      if (combomoneda[a].subpredeterminada === true) {
        predeterminada = combomoneda[a].valormoneda;
      }
    }

    for (let e = 0; e < data.length; e++) {
      for (let c = 0; c < datos.length; c++) {
        montototal = parseFloat(montototal) + parseFloat(datos[c].montodefinic);
      }
    }

    totalm = montototal * predeterminada;

    setTotaldolares(montototal);
    setTotales(totalm);
  };

  const eliminarFila = (values) => (e) => {
    e.preventDefault();
    var data = [...records];
    var elementos = [];
    var eliminado = [];

    for (let i = 0; i < data.length; i++) {
      if (values !== data[i].index) {
        elementos.push(data[i]);
      }

      if (values === data[i].index) {
        eliminado.push(data[i]);
      }
    }

    setRecords(elementos);
    calcularTotales(eliminado, elementos);
  };

  const imprimirNotaDebito = () => {
    if (accbtnndebito && accbtnndebito.toString().substring(4, 5) === "1") {
      let debt = 0;
      if (txtNumAnticipo.current.value !== "") {
        var reporte = "ReporteAnticipos";
        let opera = 3;
        let condi = "'" + numNota + "'";
        let orden = "";
        let tipo = "AN";
        let desdec = "'" + "" + "'";
        let hastac = "'" + "" + "'";
        window.open(
          op.reportes +
            "/finanzas?afiliado=" +
            afiliado +
            "&reporte=" +
            reporte +
            "&NUMPAGO=" +
            condi +
            "&OP=" +
            opera +
            "&TIPOPAGO=" +
            tipo +
            "&orden=" +
            orden +
            "&desde=" +
            desdec +
            "&hasta=" +
            hastac,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Seleccione el Anticipo a Imprimir !",
          icono: "informacion",
        });
        debt = 1;
      }

      if (debt === 1) {
        txtNumAnticipo.current.focus();
      }
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  const onGestionar = (op) => (e) => {
    if (op === 1) {
      setOperacion(op);
      setMostrar1(true);
    } else if (op === 2) {
      setOperacion(op);
      setMostrar1(true);
    } else if (op === 3) {
      setOperacion(op);
      setMostrar1(true);
    } else if (op === 4) {
      setOperacion(op);
      setMostrar1(true);
    } else if (op === 5) {
      setOperacion(op);
      setMostrar1(true);
    } else if (op === 6) {
      setOperacion(op);
      setMostrar1(true);
    } else if (op === 7) {
      setOperacion(op);
      setMostrar1(true);
    } else if (op === 8) {
      setOperacion(op);
      setMostrar1(true);
    } else if (op === 9) {
      setOperacion(op);
      setMostrar1(true);
    }
  };

  const handleAceptaDatosAnticipos = (values) => {
    setMostrar(false);

    txtNumAnticipo.current.value = values.numpago.trim();
    seleccionarAnticipo(values.numpago);
  };

  const statusanticipo = (value, reversado) => {
    let estatus = "¡ Anticipo Disponible !";
    if (reversado === 1) {
      estatus = "¡ Este Anticipo fue Reversado !";
    } else {
      if (value === 0) {
        estatus = "¡ Anticipo Disponible !";
      } else if (value === 1) {
        estatus =
          "¡ Este Anticipo fue Utilizado en la Factura N°" +
          " " +
          numfactu +
          " !";
      } else if (value === 4) {
        estatus = "¡ Este Anticipo fue Anulado !";
      } else {
        estatus = "";
      }
    }
    return estatus;
  };

  const statuscolor = (value, reversado) => {
    let estatus = "#17FF51";
    if (reversado === 1) {
      estatus = "#dc3545";
    } else {
      if (value === 0) {
        estatus = "#17FF51";
      } else if (value === 1) {
        estatus = "#F5CC00";
      } else if (value === 4) {
        estatus = "#FFF";
      }
    }
    return estatus;
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12 " style={{ margin: 0 }}>
        <div className="row col-md-12 py-2" style={{ margin: 0 }}>
          <div className="col-md-11 mx-auto py-2 card shadow h-100">
            <div className="col-md-12 row border-azul mx-auto justify-content-between rounded py-1">
              <div
                className="col-md-12 row mx-auto d-flex justify-content-between mb-1"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="col-md-12 border-azul rounded py-2 row mx-auto mb-2 azulGradiant shadow text-light justify-content-between">
                  <div className="col-md-3">
                    <h3>{tituloHeader}</h3>
                  </div>
                  <div className="col-md-6 mx-auto px-0">
                    <h4
                      className="text-center"
                      style={{
                        color: statuscolor(estatusa, estatusreve),
                      }}
                    >
                      {statusanticipo(estatusa, estatusreve)}
                    </h4>
                  </div>
                  <div className="col-md-2 d-flex justify-content-end">
                    <a href="/inicio" className="text-light ">
                      <i className="fas fa-times mx-2"></i>
                      <span className="fw-bold">Salir</span>
                    </a>
                  </div>
                </div>

                <div className="colfull col-pd-300">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      N° Anticipo:
                    </label>
                    <input
                      type="text"
                      disabled={habilitarCat}
                      ref={txtNumAnticipo}
                      name="idnotaentre"
                      onKeyUp={handleInputNumeroChange}
                      onBlur={handleInputNumeroChange}
                      className="form-control form-control-lg"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                    <button
                      disabled={habilitarCat}
                      type="button"
                      onClick={() => setMostrar(true)}
                      className="btn btn-success"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>

                <div className="col-pd-240 mx-auto">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      FECHA:
                    </label>
                    <input
                      autoComplete="off"
                      type="date"
                      disabled={!habilitado}
                      ref={txtFecha}
                      className="form-control text-uppercase fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      name="fecha"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                </div>

                <div className="colfull col400">
                  <label className="text-left">
                    ANTICIPO N°:{" "}
                    <span className="col fw-bold text-danger">
                      &nbsp;{numNota}
                    </span>
                  </label>
                </div>
              </div>

              <div
                className="colfull1070 colfull60p mx-auto mb-1"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="col-md-12 mx-auto row border-azul rounded">
                  <span className="fw-bold">Datos del Cliente</span>
                  <div className="input-group input-group-sm mb-1 col-md-5">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CEDULA/RIF:{" "}
                    </label>
                    <select
                      ref={cmbRif}
                      name="cmbrif"
                      disabled={!habilitadoCli}
                      className="form-select form-select-sm col-md-3 text-center "
                      aria-label=".form-select-sm example"
                      onChange={onChange}
                    >
                      <option value="">--</option>
                      {cmbCedula &&
                        cmbCedula.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                    </select>
                    <input
                      ref={txtRif}
                      autoComplete="off"
                      disabled={!habilitadoCli}
                      maxLength={9}
                      type="text"
                      className="form-control fs-6"
                      name="cedula"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      onKeyUp={validarCliente}
                      onBlur={validarCliente}
                      onChange={onChange}
                    />
                    <button
                      disabled={!habilitadoCli}
                      type="button"
                      onClick={() => setCatalogoCliente(true)}
                      className="btn btn-success"
                      style={{
                        visibility: visible === 0 ? "visible" : "hidden",
                      }}
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                  <div className="input-group input-group-sm mb-1 col-md-7">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      NOMBRE:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={nomCliente}
                    />
                  </div>
                  <div className="input-group input-group-sm mb-1 col-md-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      DIRECCION:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={dirCliente}
                    />
                  </div>
                </div>
              </div>

              <div
                className="colfull1070 colfull40p mx-auto mb-1 row"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="col-md-12 mx-auto row border-azul rounded">
                  <span className="fw-bold">Datos del Vendedor</span>
                  <div className="input-group input-group-sm col-pd-240 px-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                      style={{ height: "85%" }}
                    >
                      CEDULA/RIF:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      ref={txtRifVende}
                      className="form-control fs-6"
                      style={{ height: "85%" }}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={cedRif}
                    />
                  </div>
                  <div className="input-group input-group-sm col-md-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                      style={{ height: "85%" }}
                    >
                      NOMBRE:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      style={{ height: "85%" }}
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={nomVendedor}
                    />
                  </div>
                </div>
                <div className="col-md-6"></div>
              </div>

              <div className="col-md-12 row mx-auto px-0 m-0">
                <div className="input-group input-group-sm mb-1 px-0 border-azul rounded col-md-12">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    CONCEPTO:
                  </label>
                  <textarea
                    className="form-control uppercase fs-6"
                    ref={txtConcepto}
                    disabled={!habilitado}
                    aria-label="With textarea"
                    style={{ minHeight: 50 }}
                    defaultValue={""}
                  />
                </div>

                <div
                  className="col-3 row m-0 px-0 d-flex justify-content-center border-azul py-2"
                  style={{ background: "#cfe2ff", borderRadius: "3px" }}
                >
                  <div className="col-6 d-flex justify-content-center mb-1">
                    <button
                      ref={btnAcepta}
                      disabled={!habilitado}
                      style={{ height: "80px", fontSize: "14px" }}
                      onClick={onGestionar(1)}
                      className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                    >
                      <i className="fas fa-money-bill-alt fs-5 mr-2"></i>{" "}
                      Efectivo Bs
                    </button>
                  </div>
                  <div className="col-6 d-flex justify-content-center mb-1">
                    <button
                      ref={btnAcepta}
                      disabled={!habilitado}
                      style={{ height: "80px", fontSize: "14px" }}
                      onClick={onGestionar(7)}
                      className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                    >
                      <i className="fas fa-dollar-sign fs-5 mr-2"></i> Divisas
                    </button>
                  </div>
                  <div className="col-6 d-flex justify-content-center mb-1">
                    <button
                      ref={btnAcepta}
                      disabled={!habilitado}
                      style={{ height: "80px", fontSize: "14px" }}
                      onClick={onGestionar(2)}
                      className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                    >
                      <i className="fas fa-credit-card fs-5 mr-2"></i> Tarjeta
                      de Debito
                    </button>
                  </div>
                  <div className="col-6 d-flex justify-content-center mb-1">
                    <button
                      ref={btnAcepta}
                      disabled={!habilitado}
                      style={{ height: "80px", fontSize: "14px" }}
                      onClick={onGestionar(3)}
                      className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                    >
                      <i className="fab fa-cc-visa fw-bold fs-5 mr-2"></i>{" "}
                      Tarjeta de Credito
                    </button>
                  </div>
                  <div className="col-6 d-flex justify-content-center mb-1">
                    <button
                      ref={btnAcepta}
                      disabled={!habilitado}
                      style={{ height: "80px", fontSize: "14px" }}
                      onClick={onGestionar(6)}
                      className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                    >
                      <i className="fas fa-money-check fs-5 mr-2"></i> Deposito
                      Bancario
                    </button>
                  </div>
                  <div className="col-6 d-flex justify-content-center mb-1">
                    <button
                      ref={btnAcepta}
                      disabled={!habilitado}
                      style={{ height: "80px", fontSize: "14px" }}
                      onClick={onGestionar(5)}
                      className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                    >
                      <i className="fas fa-laptop fs-5 mr-2"></i> Transferencia
                      Bancaria
                    </button>
                  </div>
                  <div className="col-6 d-flex justify-content-center">
                    <button
                      ref={btnAcepta}
                      disabled={!habilitado}
                      style={{ height: "80px", fontSize: "14px" }}
                      onClick={onGestionar(4)}
                      className="btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
                    >
                      <i className="fas fa-mobile-alt fs-5 mr-2"></i> Pago Movil
                    </button>
                  </div>
                  <div className="col-6 d-flex justify-content-center"></div>
                </div>

                <div className="col-9 px-0">
                  <div className="col-12 px-0">
                    <TblContainer
                      container={{
                        height: "280px",
                        width: "100%",
                        overflow: "auto",
                        padding: "2px",
                      }}
                    >
                      <TblHead />
                      <TableBody className="overflow-hidden table-bordered">
                        {records &&
                          records.map((item, index) => (
                            <TableRow
                              key={index}
                              style={{ padding: "0", cursor: "pointer" }}
                            >
                              <TableCell className="align-baseline text-center">
                                {item.forma}
                              </TableCell>
                              <TableCell className="align-middle text-right">
                                {formatMoneda(
                                  item.montos
                                    .toString()
                                    .replace(",", "")
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )}
                              </TableCell>
                              <TableCell className="align-baseline text-right">
                                {formatMoneda(
                                  item.montoalcambio
                                    .toString()
                                    .replace(",", "")
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )}
                              </TableCell>
                              <TableCell className="align-baseline text-center">
                                <button
                                  className="btn btn-sm mx-1 btn-danger"
                                  disabled={!habilitado}
                                  onClick={eliminarFila(item.index)}
                                >
                                  <i className="fa fa-trash"></i>{" "}
                                </button>
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </TblContainer>
                  </div>
                  <div
                    className="col-12 px-0 row m-0 d-flex align-items-center border-azul"
                    style={{ borderRadius: "3px", fontSizeAdjust: "0.5" }}
                  >
                    <div className="col-12 row m-0 px-0 border-azul">
                      <div className="col-6 px-0">
                        <div className="col-pd-280 mx-auto">
                          <img src="imagenes/logo.ico" className="img-fluid" />
                        </div>
                      </div>
                      <div className="col-2"></div>
                      <div
                        className="col-4 ml-auto px-0 row m-0 d-flex align-items-center border-azul py-2"
                        style={{
                          background: "#cfe2ff",
                          borderRadius: "3px",
                          fontSizeAdjust: "0.5",
                        }}
                      >
                        <div
                          className="col-12 row m-0"
                          style={{ fontSizeAdjust: "0.5" }}
                        >
                          <label className="col-4 px-1 text-left fs-5">
                            Total $:{" "}
                          </label>
                          <span className="col px-0 fw-bold text-right fs-5">
                            &nbsp;
                            {formatMoneda(
                              totaldolares
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </span>
                        </div>
                        <div
                          className="col-12 row m-0"
                          style={{ fontSizeAdjust: "0.5" }}
                        >
                          <label className="col-4 px-1 text-left fs-5">
                            Total Bs:{" "}
                          </label>
                          <span className="col px-0 fw-bold text-right fs-5">
                            &nbsp;
                            {formatMoneda(
                              totales
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="colfull40p row m-0">
                <div className="col-md-12"></div>
              </div>
              <div className="col-md-12 mt-auto px-0">
                {visibleBtn === "visible" ? (
                  <div className="col-pd-340">
                    <div className="col-md-12 row m-0 px-0">
                      <button
                        disabled={!habilitadoBot}
                        ref={btnIncluir}
                        onClick={onBotones(1)}
                        className="btn btn-sm col ml-1 btn-primary rounded-pill"
                        title="Incluir Nota de Entrega"
                      >
                        <i className="fas fa-plus"> Incluir </i>{" "}
                      </button>
                      <button
                        disabled={!habilitadoBot}
                        ref={btnConsultar}
                        onClick={onBotones(4)}
                        className="btn btn-sm col ml-1 btn-info rounded-pill"
                        title="Consultar Nota de Entrega"
                      >
                        <i className="fas fa-eye"> Consultar</i>{" "}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div
                    className={`${
                      imagenanticipo !== null && imagendivisa !== null
                        ? "col-pd-700 row m-0 ml-auto"
                        : imagenanticipo !== null && imagendivisa === null
                        ? "col-pd-530 row m-0 ml-auto"
                        : imagenanticipo === null && imagendivisa !== null
                        ? "col-pd-530 row m-0 ml-auto"
                        : "col-pd-350 row m-0 ml-auto"
                    }`}
                  >
                    {opea === 4 && imagenanticipo !== null ? (
                      <button
                        onClick={() => setModalAnticipo(true)}
                        disabled={opea === 4 ? false : true}
                        className="btn btn-sm col ml-1 btn-info rounded-pill"
                        title="Visualizar Imagen Anticipo"
                      >
                        <i className="fas fa-images"> Imagen Anticipo</i>
                      </button>
                    ) : (
                      ""
                    )}

                    {opea === 4 && imagendivisa !== null ? (
                      <button
                        onClick={() => setModalDivisa(true)}
                        disabled={opea === 4 ? false : true}
                        className="btn btn-sm col ml-1 btn-warning rounded-pill"
                        title="Visualizar Imagen Divisa"
                      >
                        <i className="fas fa-images"> Imagen Divisa</i>
                      </button>
                    ) : (
                      ""
                    )}

                    {opea === 4 ? (
                      <button
                        onClick={imprimirNotaDebito}
                        disabled={opea === 4 ? false : true}
                        className="btn btn-sm col ml-1 btn-primary rounded-pill"
                        title="Imprimir Nota de Entrega"
                      >
                        <i className="fa fa-print"> Imprimir</i>
                      </button>
                    ) : (
                      ""
                    )}

                    {opea === 4 ? (
                      ""
                    ) : (
                      <button
                        ref={btnAcepta}
                        disabled={opea === 4 ? true : habilitadoBot}
                        onClick={onBotones(5)}
                        className="btn btn-sm col ml-1 rounded-pill btn-success"
                      >
                        <i className="fas fa-check-circle">
                          {" "}
                          Procesar Anticipo
                        </i>
                      </button>
                    )}

                    <button
                      ref={btnCancela}
                      disabled={habilitadoBot}
                      onClick={onBotones(6)}
                      className="btn btn-danger col ml-1 btn-sm rounded-pill"
                    >
                      <i className="fas fa-window-close"> Cancelar</i>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <CatalogoCliente
        show={catalogoCliente}
        nomid="cliente"
        onHideCancelar={() => setCatalogoCliente(false)}
        onHideAceptaCatalogo={onCatalogoCliente}
      />

      <ImagenAnticipo
        show={modalAnticipo}
        imagenanticipo={imagenanticipo}
        onHideCancelar={() => setModalAnticipo(false)}
      />

      <ImagenDivisa
        show={modalDivisa}
        imagendivisa={imagendivisa}
        onHideCancelar={() => setModalDivisa(false)}
      />

      <CatalogoListAnticipos
        show={mostrar}
        idcliente={0}
        tipo={"AN"}
        estatus={0}
        onHideCancelar={() => setMostrar(false)}
        onHideAceptaCatalogo={handleAceptaDatosAnticipos}
      />

      <ProcesosMontosAnticipos
        show={mostrar1}
        ope={operacion}
        data={records}
        idclients={idCliente}
        onHideCancelar={() => setMostrar1(false)}
        onHideAceptaData={handleAceptaDatos}
      />

      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje mensaje={mensaje} onHide={handleCloseMensaje} />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default TablaAnticipos;



// WEBPACK FOOTER //
// ./src/components/finanzas/tablaAnticipo.js